export const PLAYERS_PER_PAGE = 50;
export const PLAYER_SCORES_PER_PAGE = 10;
export const LEADERBOARD_SCORES_PER_PAGE = 10;
export const CLANS_PER_PAGE = 10;
export const Ranked_Const = {
	MAX_STARS: 18,
	MIN_STARS: 0,
	STAR_GRANULARITY: 0.05,
	STAR_STEP: 40,
};
export const Unranked_Const = {
	MAX_STARS: 42,
	MIN_STARS: 0,
	STAR_GRANULARITY: 0.05,
	STAR_STEP: 100,
};
